import { combineReducers } from 'redux';

import { CLOSE_SHARE_MODAL, FETCH_AUDIT_REQUEST, OPEN_SHARE_MODAL } from 'modules/audits/actionTypes';
import { DETAILS_SHARE_MODAL } from 'modules/audits/constants';
import loading from 'modules/global/reducers/generic.loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import isOpen from './isOpen';
import send from './send';
import url from './url';

/**
 * @typedef {{
 *   open: boolean,
 *   auditId: string,
 *   source: string | null,
 *   url: import("./url").AuditsUIDetailsShareURLReducer,
 *   send: import("./send").AuditsUIDetailsShareSendReducer,
 *   loading: boolean,
 * }} AuditsUIDetailsShareReducer
 */

export default combineReducers({
  url,
  send,
  open: isOpen,
  auditId: createReducer(null, {
    [OPEN_SHARE_MODAL]: (_, { payload: auditId }) => auditId ?? null,
    [CLOSE_SHARE_MODAL]: () => null,
    [LOCATION_CHANGE]: () => null,
  }),
  source: createReducer(null, {
    [OPEN_SHARE_MODAL]: (_, { meta }) => meta?.source ?? null,
    [CLOSE_SHARE_MODAL]: () => null,
    [LOCATION_CHANGE]: () => null,
  }),
  loading: loading(FETCH_AUDIT_REQUEST, { global: { matcher: action => action.meta?.source === DETAILS_SHARE_MODAL } }),
});
